var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { observeElementIntersect } from "../../shared/utils/lazyloading/lazyloading";
function setSrc(target) {
    if (target && target.dataset) {
        if (target.dataset.src) {
            target.setAttribute('src', target.dataset.src);
            target.removeAttribute('data-src');
        }
        else if (target.dataset.srcset) {
            target.setAttribute('srcset', target.dataset.srcset);
            target.removeAttribute('data-srcset');
        }
    }
}
export function LazyLoadContainer(_a) {
    var { lazyload = true, lazyClass = '', children, className, component } = _a, other = __rest(_a, ["lazyload", "lazyClass", "children", "className", "component"]);
    const lazyLoadContainer = useRef(null);
    const [isIntersecting, setIntersecting] = useState(false);
    useEffect(() => {
        function setLazyClass() {
            setIntersecting(true);
        }
        if (lazyload && lazyLoadContainer.current) {
            const lazyImages = [
                ...lazyLoadContainer.current.querySelectorAll('img[data-src], img[data-srcset], source[data-srcset], video[data-src], video[data-srcset], iframe[data-src], iframe[data-srcset]'),
            ];
            if (lazyImages.length) {
                observeElementIntersect(lazyImages, setSrc, { rootMargin: '150px' });
            }
            if (lazyClass) {
                const lazyImage = [lazyLoadContainer.current];
                observeElementIntersect(lazyImage, setLazyClass, { rootMargin: '150px' });
            }
        }
    }, [lazyload, lazyClass]);
    const Component = component || 'div';
    return (_jsx(Component, Object.assign({ ref: lazyLoadContainer }, other, { className: `${className ? className : ''} ${isIntersecting || (!lazyload && lazyClass) ? lazyClass : ''}`, children: children })));
}
